// extracted by mini-css-extract-plugin
export default {"root":"xE3WGC1dfK","searchAndTabSelection":"Kr_3RgvnFq","search":"J0SgaXl4lu","tabSelector":"HoCfI6A9ZQ","tableContainer":"MHC1QjXPBA"};